import { format } from 'date-fns';
import {
  VacancyFeedback,
  ParsedVacancyFeedback,
  ParsedVacanciesFeedbackType,
  FeedbackStatusEnum,
  Status,
} from './types';

const parseStatus = (status: string): Status => {
  switch (status) {
    case FeedbackStatusEnum.NEW:
      return {
        sort: 100,
        message: 'Ожидайте ответа.',
        color: 'blue',
      };
    case FeedbackStatusEnum.INTERVIEW:
      return {
        sort: 200,
        message: 'Приглашаем вас на собеседование.',
        color: 'purple',
      };
    case FeedbackStatusEnum.INVITATION:
      return {
        sort: 300,
        message: 'Приглашаем вас на работу.',
        color: 'green',
      };
    case FeedbackStatusEnum.REFUSAL:
      return {
        sort: 400,
        message:
          'К сожалению в данный момент мы не готовы пригласить вас на работу.',
        color: 'red',
        refusal: true,
      };
    case FeedbackStatusEnum.CANDIDATE_REFUSAL:
      return {
        sort: 500,
        message: 'Вы отказались от вакансии.',
        refusal: true,
      };
    default:
      return {
        sort: 1000,
        message: '',
      };
  }
};

const parseFeedback = (
  feedback: VacancyFeedback
): Readonly<ParsedVacancyFeedback> =>
  Object.freeze({
    ...feedback,
    id: feedback?.id || '',
    vacancy_id: feedback?.vacancy_id || '',
    state: {
      ...parseStatus(feedback?.state || ''),
      stateName: feedback?.state_name || '',
      stateDate: format(feedback?.date_state || '', 'DD.MM.YYYY'),
      stateId: feedback?.state || '',
    },
    user_can_cancel: feedback.user_can_cancel,
    vacancy_name: feedback?.vacancy_name || '',
    partner_logo: feedback?.partner_logo || '',
    date_created: format(feedback?.date_created || '', 'DD.MM.YYYY'),
    partner_name: feedback?.partner_name || '',
  });

const parseFeedbacks = (
  feedbacks: Array<VacancyFeedback>
): ParsedVacanciesFeedbackType =>
  feedbacks.map(parseFeedback).sort((a, b) => a.state.sort - b.state.sort);

export default parseFeedbacks;



// WEBPACK FOOTER //
// ./src/services/api/vacancies/utils/parseFeedbacks.ts